<template>
  <gg-modal :is-active="opened" @close="close">
    <template v-slot:toolbar>
      IRTP Lock Warning
    </template>
    <template v-slot:body>
      <p class="mb-2">
        Saving these changes will result in "{{ domain }}" being <b>transfer locked for 60 days</b>.
      </p>
      <p class="mb-2">
        If you plan on transferring your domain soon, use the option below to bypass the transfer lock.
        If you have any questions please contact Support.
      </p>
      <v-checkbox
        v-model="bypass_irtp"
        color="primary"
        :true-value="1"
        :false-value="0"
        label="Bypass Transfer Lock"
        hide-details
      />
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">
        Cancel
      </gg-btn>
      <gg-btn primary @click="confirm">
        Confirm
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import modalMixin from '@/mixins/modal'

export default {
  name: 'LockModal',
  mixins: [modalMixin],
  data () {
    return {
      bypass_irtp: 0
    }
  },
  props: {
    domain: {
      required: true,
      type: String,
    },
  },
  methods: {
    confirm () {
      this.$emit('confirm', this.bypass_irtp)
      this.close()
    },
  },
}
</script>
